import { useMemo } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { resolveTermsAcceptanceRequired } from '@/lib/terms-acceptance'

export function useTermsAcceptanceRequired(): boolean {
  const { guard, isLoading, isCollaborator, institution, collaborator } = useAuth()

  return useMemo(() => {
    if (guard !== 'institution' || isLoading) return false
    const acceptor = isCollaborator ? collaborator : institution
    return resolveTermsAcceptanceRequired(acceptor, { failSafeWhenMissing: true })
  }, [guard, isLoading, isCollaborator, institution, collaborator])
}
